/**
 * Avatar presentation, shared so the same person is the same colour on every
 * screen. A per-screen helper drifts, and an inconsistent colour reads as a
 * different person.
 */

const AVATAR_COLOURS = ['bg-accent', 'bg-violet', 'bg-teal', 'bg-warn', 'bg-success'] as const;

/** Deterministic: the same name always maps to the same swatch. */
export function avatarColour(seed: string): string {
  let hash = 0;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 31 + seed.charCodeAt(index)) % 997;
  }
  return AVATAR_COLOURS[hash % AVATAR_COLOURS.length]!;
}

export function initialOf(name: string): string {
  return name.trim().charAt(0).toUpperCase() || '?';
}
